import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  langContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "row",
    padding: 2,
    borderRadius: 5,
    position: "absolute",
    top: 10,
    right: 10,
    height: 52,
    backgroundColor: "#FFFFFF",
  },
  langButton: {
    padding: 0,
    height: 47,
    minWidth: 50,
    borderColor: "#000000",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    border: "2px solid #077A97",
  },
  langButtonSelected: {
    padding: 0,
    height: 47,
    minWidth: 47,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    backgroundColor: "#077A97",
    border: "2px solid #FFFFFF",
  },
  langBtSelected: {
    color: "#ffffff",
  },
  langBt: {
    backgroundColor: "#ffffff",
    color: "#000000",
  },

  langLabel: {
    color: "000000",
  },

  langLabelPressed: {
    color: "#FFFFFF",
  },
  flagIcon: {
    width: 24,
    height: 18,
    marginBottom: 2,
  },
});

export default styles;
